/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A value/label pair for a select control.
 * @export
 * @interface LabelledChoice
 */
export interface LabelledChoice {
    /**
     * 
     * @type {string}
     * @memberof LabelledChoice
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof LabelledChoice
     */
    label: string;
}

/**
 * Check if a given object implements the LabelledChoice interface.
 */
export function instanceOfLabelledChoice(value: object): value is LabelledChoice {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function LabelledChoiceFromJSON(json: any): LabelledChoice {
    return LabelledChoiceFromJSONTyped(json, false);
}

export function LabelledChoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelledChoice {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
    };
}

export function LabelledChoiceToJSON(json: any): LabelledChoice {
    return LabelledChoiceToJSONTyped(json, false);
}

export function LabelledChoiceToJSONTyped(value?: LabelledChoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

